import {TabsProps} from "antd";
import React from "react";
import {FIELD_TYPE, tabKeys} from "types/enums";
import List1 from "./List1/List1";
import List2 from "./List2/List2";
import List3 from "./List3/List3";

const {INPUT, SELECT, DATE, NUMBER} = FIELD_TYPE;
const items: TabsProps["items"] = [
  {
    key: tabKeys.MEDICINE_STORE.LIST_1,
    label: `Đơn thuốc kê`,
    children: <List1></List1>,
  },
  {
    key: tabKeys.MEDICINE_STORE.LIST_2,
    label: `Đơn thuốc bán`,
    children: <List2></List2>,
  },
  {
    key: tabKeys.MEDICINE_STORE.LIST_3,
    label: `Đơn hoàn trả`,
    children: <List3></List3>,
  },
];
const inputFields: any[] = [
  {
    type: INPUT,
    label: "Mã phiếu khám",
    name: "ma-kb",
    expand: false,
  },
  {
    type: INPUT,
    label: "Mã bệnh nhân",
    name: "ma-benh-nhan",
    expand: false,
  },
  {
    type: INPUT,
    name: "don-ke-id",
    label: "Mã đơn thuốc kê",
    expand: false,
  },

  {
    type: INPUT,
    label: "Họ tên",
    name: "ho-ten",
    expand: false,
  },
  {
    type: DATE,
    label: "Ngày tạo từ",
    name: "start-ngay-tao",
    expand: false,
  },
  {
    type: DATE,
    label: "Ngày tạo đến",
    name: "end-ngay-tao",
    expand: false,
  },
  {
    type: INPUT,
    label: "Mã đơn thuốc mua",
    name: "id",
    expand: true,
  },
  {
    type: SELECT,
    label: "Giới tính",
    name: "gioi-tinh",
    expand: true,
    options: [
      {value: "NA", label: "Nam"},
      {value: "NU", label: "Nữ"},
    ],
  },
  {
    type: INPUT,
    label: "Số thẻ BHYT",
    name: "so-the-bhyt",
    expand: true,
  },
  {
    type: INPUT,
    label: "Số điện thoại",
    name: "dien-thoai",
    expand: true,
  },
  {
    type: DATE,
    label: "Ngày sinh từ",
    name: "ngay-sinh-start",
    expand: true,
  },
  {
    type: DATE,
    label: "Ngày sinh đến",
    name: "ngay-sinh-end",
    expand: true,
  },
  {
    type: DATE,
    label: "Ngày mua từ",
    name: "start-ngay-mua",
    expand: false,
  },
  {
    type: DATE,
    label: "Ngày mua đến",
    name: "end-ngay-mua",
    expand: false,
  },
  {
    type: DATE,
    label: "Ngày trả thuốc",
    name: "thoiGianTra",
    expand: false,
  },
  // {
  //   type: SELECT,
  //   label: "Trạng thái đơn thuốc",
  //   expand: [{value:'CB'}],
  // },
];

export {inputFields, items};
